const MuiStepper = {
  styleOverrides: {
    root: {
      backgroundColor: 'transparent',
    },
  },
};

export default MuiStepper;
